import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotifymodalComponent } from 'src/app/notifymodal/notifymodal.component';
import { PersonelService } from 'src/app/services/personel.service';



@Component({
  selector: 'app-reset-modal',
  templateUrl: './reset-modal.component.html',
  styleUrls: ['./reset-modal.component.css']
})
export class ResetModalComponent implements OnInit {
  /*
    public resetForm = new FormGroup({
      pass: new FormControl(''),
      rep: new FormControl(''),
    });
  */

  text: string = "";

  constructor(
    public personelService:PersonelService,
    private dialogRef: MatDialogRef<ResetModalComponent>,
    public dialog:MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    dialogRef.disableClose = true;
    this.text = data.text;
  }

  ngOnInit(): void {

    //this.resetForm.controls["pass"].setValidators([Validators.minLength(6)]);
    //this.resetForm.controls["rep"].setValidators([Validators.minLength(6)]);

    /*
    ({
      tc: this.data.TcNumber, 
      sgk: this.data.SgkNumber,
      name:this.data.Name,
      surname:this.data.Surname,
      company:this.data.CompanyName,
      email:this.data.Email
    });
*/
    //console.log(this.data);
  }

  send(s: string) {

    if (s == 'yes') {
      if(this.data.method == "reset"){
        this.personelService.resetPassword(this.data.user).subscribe(res => {
          //console.log("reset: \n"+ res);
          this.dialog.open(NotifymodalComponent, {
            data: {
             isSuccess:true, 
             text:"Şifre sıfırlama başarılı.",
             subject:"Şifre Sıfırlama"
            }
          });
        },
        error => {
          this.dialog.open(NotifymodalComponent, {
            data: {
              isSuccess:false, 
              text:"Şifre sıfırlama başarılı.",
              subject:"Şifre Sıfırlama"
            }
          });
        });
      }
      if(this.data.method == "change"){
        this.personelService.changeActivity(this.data.user).subscribe(res => {
          //console.log("change: \n"+ res);
          this.dialog.open(NotifymodalComponent, {
            data: {
              isSuccess:true, 
              text:"Aktif/Pasif değişimi başarılı.",
              subject:"Aktif/Pasif"
            }
          });
        },
        error => {
          this.dialog.open(NotifymodalComponent, {
            data: {
              isSuccess:false, 
              text: error.error.error,
              subject:"Aktif/Pasif"
            }
          });
        });

      }
      this.dialogRef.close({changed:'true'});
    }
    
    if (s == 'no') {
      this.dialogRef.close({changed:'false'});
    }
  }


  /*
    get pass() { return this.resetForm.get('pass'); }
  
    get rep() { return this.resetForm.get('rep'); }
    */
}
